/* SidebarOption.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["isSelected"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React, { useCallback } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _19 = "@media (hover:hover){._1rjni1yw:hover{background-color:var(--ds-background-selected-hovered,#cce0ff)}._13kh19ru:active{background-color:var(--ds-background-selected-pressed,#85b8ff)}}";
const _18 = "._1di619ru:active{background-color:var(--ds-background-selected-pressed,#85b8ff)}";
const _17 = "._5wra1yqz{border-left-color:var(--ds-border-selected,#0c66e4)}";
const _16 = "._1p3lnqa1{border-left-style:solid}";
const _15 = "._t6vd1bk5{border-left-width:var(--ds-border-width-outline,2px)}";
const _14 = "._syazaqb7{color:var(--ds-text-selected,#0c66e4)}";
const _13 = "._bfhkfg4m{background-color:var(--ds-background-selected,#e9f2ff)}";
const _12 = "@media (hover:hover){._1rjn16qz:hover{background-color:var(--ds-surface-overlay-hovered,#f1f2f4)}._13khvq0a:active{background-color:var(--ds-surface-overlay-pressed,#dcdfe4)}}";
const _11 = "._1di6vq0a:active{background-color:var(--ds-surface-overlay-pressed,#dcdfe4)}";
const _10 = "._y3gn1e5h{text-align:left}";
const _9 = "._1wyboxwj{font-size:.875rem}";
const _8 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _7 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const _6 = "._u5f3pxbi{padding-right:var(--ds-space-200,1pc)}";
const _5 = "._19bvpxbi{padding-left:var(--ds-space-200,1pc)}";
const _4 = "._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}";
const _3 = "._ca0qutpp{padding-top:var(--ds-space-150,9pt)}";
const _2 = "._80omtlke{cursor:pointer}";
const _ = "._19it66vy{border:var(--ds-border-width-outline,2px) solid transparent}";
// Using styled button instead of Pressable so we can use hover media query
const OptionButton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      isSelected
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19it66vy _80omtlke _ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _bfhk1bhr _syaz1fxt _1wyboxwj _y3gn1e5h _1di6vq0a _1rjn16qz _13khvq0a", __cmplp.isSelected && "_bfhkfg4m _syazaqb7 _t6vd1bk5 _1p3lnqa1 _5wra1yqz _1di619ru _1rjni1yw _13kh19ru", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OptionButton.displayName = 'OptionButton';
}
const optionLabelStyles = xcss({
  flex: '2 1 auto',
  maxWidth: '90%',
  wordWrap: 'break-word'
});
const numberOfSelectionsStyles = xcss({
  flex: '1 1 auto',
  minWidth: 'size.100',
  // Reserving space for this component to prevent shifting the sidebar when the first selection is made
  textAlign: 'right'
});
export const SidebarOption = _ref2 => {
  let {
    id,
    isSelected,
    label,
    numberOfSelections,
    onClick
  } = _ref2;
  const handleClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);
  return /*#__PURE__*/_jsx(OptionButton, {
    role: "tab",
    "aria-selected": isSelected,
    onClick: handleClick,
    isSelected: isSelected,
    children: /*#__PURE__*/_jsxs(Inline, {
      spread: "space-between",
      space: "space.100",
      as: "span",
      children: [/*#__PURE__*/_jsx(Box, {
        xcss: optionLabelStyles,
        children: label
      }), /*#__PURE__*/_jsx(Box, {
        xcss: numberOfSelectionsStyles,
        children: numberOfSelections > 0 && numberOfSelections
      })]
    })
  });
};